const config = {
  //backendUrl: "http://localhost:3001/api",
  backendUrl: "https://backend.handpik.ai/api",
  agentBackendUrl: "http://localhost:8000",
};

export default config;
